<eif-custom-table
	[columns]="tableColumns"
	[rows]="validationResultRecords"
	[loading]="isTableLoading"
	[pagination]="null"
	[idField]="'RowNumber'"
	[cardTemplate]="validationResultCard"
	[expandTemplate]="validationErrorsExpand"
	[cardExpandTemplate]="validationErrorsExpand"
	#customTable>
</eif-custom-table>

<ng-template
	#validationResultCard
	let-row>
	<div class="eif-card">
		<div class="eif-card-header">
			<div class="label">{{ 'supplier-upload-step3.ValidationStatus' | translate }}</div>
			<div>
				<span class="tag upload-doc-state-{{ row.ValidationStatus }}">
					{{ row.ValidationStatus | translate: 'list-uploadedSupplierRecordState' }}
				</span>
			</div>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'supplier-upload-step3.SupplierRecordsRow' | translate }}</div>
			<div>{{ row.RowNumber }}</div>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'supplier-upload-step3.SupplierRecordsBuyerVatNumber' | translate }}</div>
			<div>{{ row.BuyerCountryCode }}{{ row.BuyerVatNumber }}</div>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'supplier-upload-step3.SupplierRecordsBuyerManagerName' | translate }}</div>
			<div>
				<div>{{ row.BuyerManagerName }}</div>
				<div>{{ row.BuyerManagerUsername }}</div>
			</div>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'supplier-upload-step3.SupplierRecordsSupplier' | translate }}</div>
			<div>
				<div>{{ row.SupplierName }}</div>
				<div>{{ row.SupplierCountryCode }}{{ row.SupplierVatNumber }}</div>
			</div>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'supplier-upload-step3.SupplierRecordsSupplierLanguageCode' | translate }}</div>
			<div>{{ row.SupplierLanguageCode | uppercase }}</div>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'supplier-upload-step3.SupplierRecordsSupplierUserName' | translate }}</div>
			<div>
				<div>{{ row.SupplierUserName }}</div>
				<div>{{ row.SupplierUserEmail }}</div>
			</div>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'supplier-upload-step3.SupplierRecordsConfirmingContract' | translate }}</div>
			<div>{{ row.ContractNumber }}</div>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'supplier-upload-step3.SupplierRecordsSupplierBankCountryCode' | translate }}</div>
			<div>{{ row.BankCountry }}</div>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'supplier-upload-step3.SupplierRecordsSupplierIbanSwift' | translate }}</div>
			<div>
				<div>{{ row.SupplierIban }}</div>
				<div>{{ row.SupplierSwift }}</div>
			</div>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'supplier-upload-step3.SupplierRecordsSupplierBankNameAddress' | translate }}</div>
			<div>
				<p>{{ row.BankName }}</p>
				<p>{{ row.BankAddress }}</p>
			</div>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'supplier-upload-step3.SupplierRecordsActivePaymentRequest' | translate }}</div>
			<div>{{ row.ActivePaymentRequest | uppercase | translate: 'list-uploadedSupplierYesNo' }}</div>
		</div>
		@if (showColumnActiveAutomaticFundingRequest) {
			<div class="eif-card-section">
				<div class="label">{{ 'supplier-upload-step3.SupplierRecordsActiveAutomaticFundingRequest' | translate }}</div>
				<div>{{ row.ActiveAutomaticFundingRequest | uppercase | translate: 'list-uploadedSupplierYesNo' }}</div>
			</div>
		}
	</div>
</ng-template>

<ng-template
	#validationErrorsExpand
	let-row>
	<div class="label">{{ 'supplier-upload-step3.DocumentRecordsValidationErrors' | translate }}</div>
	<ul>
		@for (lineError of row.ValidationErrors; track $index) {
			@if (lineError?.Values[0]) {
				<li>
					{{ lineError?.Values[0] }}
				</li>
			}
		}
	</ul>
</ng-template>
